module.exports = __webpack_public_path__ + "assets/youtube-logo.51ced8fb.svg";